export default __webpack_public_path__ + "static/media/i-interior-1.485453bf.svg";